import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { BaseService } from './base.service';
import { MessageService } from './message.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class CteOSService extends BaseService {
  private emailCte = new Subject<{ cteId: number }>();
  solicitacaoAbrirEnvioEmail = this.emailCte.asObservable();

  constructor(private http: HttpClient, private message: MessageService) { super(); }

  consultar(filtros) {
    return this.http.post(this.UrlService + 'CteOS/Consultar', filtros)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  salvar(dados): Observable<number> {
    return this.http.post(this.UrlService + 'CteOS/Salvar', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  salvarRascunho(dados): Observable<number> {
    return this.http.post(this.UrlService + 'CteOS/SalvarRascunho', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  enviar(cteOSId: number): Observable<{ cteOSId: number, cteOSNum: number }> {
    return this.http.post(this.UrlService + 'CteOS/Enviar', cteOSId)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  buscarDadosCteOS(cteOSId: number) {
    return this.http.get(this.UrlService + `CteOS/${cteOSId}`)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  cancelarCteOS(cteId: number, motivo: string) {
    const param = { cteId, motivo };
    return this.http.post(this.UrlService + 'CteOS/cancelar', param)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  imprimirCteOS(cteOSId: number, formato: any) {
    const params = { cteOSId, formato };

    return this.http
      .post(this.UrlService + 'CteOS/ImprimirCteOS', params, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }

  previsualizarCteOS(dados) {
    return this.http.post(this.UrlService + 'CteOS/PrevisualizarCteOS', dados, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }

  buscarEmailsCTeOS(cteOSId) {
    return this.http.get(this.UrlService + `CteOS/BuscarEmailsCTeOS/${cteOSId}`)
      .pipe(map(super.extractData)
        , catchError(super.serviceError));
  }

  enviarEmail(cteOSId: number, emails: string[], emitirBoleto: boolean) {
    const dados = { cteOSId, emails, emitirBoleto };
    return this.http.post(this.UrlService + 'CteOS/EnviarEmail', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }

  abrirEnvioEmail(cteId: number) {
    if (cteId) {
      this.emailCte.next({ cteId });
    }
  }

  xmlCteOSCancelado(cteOSId) {
    return this.http
      .post(this.UrlService + 'CteOS/XmlCteOSCancelado/', cteOSId, { responseType: 'blob' })
      .pipe(catchError(super.parseErrorBlob));
  }

  verificaConfirmacaoImpressaoBoleto(cteOSId: number, modo: 'todos' | 'email') {
    const dados = { cteOSId, modo };
    return this.http
      .post(this.UrlService + 'CteOS/VerificaConfirmacaoImpressaoBoleto', dados)
      .pipe(map((res: any) => res.data));
  }

  baixarBoleto(cteId: number) {
    return this.http
      .post(this.UrlService + 'CteOS/gerarBoleto', cteId)
      .pipe(map((res: any) => res.data));
  }

  cartaCorrecao(dados: any) {
    return this.http.post(this.UrlService + 'CteOS/GerarCartaCorrecao', dados)
      .pipe(map(super.extractData), catchError(super.serviceError));
  }
}
